<template>
	<AddAlertPopup :adding-alert="isShowingAlert" :bind-alert="this.showAlert" ref="popupForm"/>

	<div class="container-fluid">

		<div class="row default-margin-top-content">
			<div class="col-md-12 col-sm-12">
				<div class="row">
					<div class="d-flex justify-content-between align-items-center  content-header ">
						<div class="col-md-10 col-sm-2">

						</div>
						<div class="col-md-2 col-sm-4 button-panel d-flex align-items-start justify-content-end">
							<button class="btn btn-add" @click="showAddAlertForm" data-bs-toggle="modal" data-bs-target="#alertModalWizard">
								<img src="/svgs/add.svg" alt="">
								დამატება
							</button>
						</div>
					</div>

					<div class="content-body">
						<transition name="fade" mode="in-out">
							<div>
								<div class="d-none responsive-sensor-container" v-if="alerts && alerts.list && alerts.list.length">
									<ul class="sensor-list-responsive">
										<li v-for="alert in alerts.list" :key="alert.id">
											<div class="d-flex justify-content-between each-responsive-sensor">
												<div class="sensor-name d-flex flex-column">
													{{ alert.name.substr(0, 22) }}
													{{ alert.name.length > 22 ? '...' : '' }}
													<sub>
														{{
															alert.value1 === "0" ? 'ტემპერატურის დაწევისას' : 'ტემპერატურის აწევისას'
														}}
													</sub>
												</div>
												<div class="sensor-data">
													{{ alert.devices }}
													<img src="/svgs/edit2.svg" data-bs-toggle="modal" data-bs-target="#alertModalWizard" @click.prevent="showEditAlert(alert.id)" alt="">
												</div>
											</div>
										</li>
									</ul>
								</div>

								<div class="d-none d-md-block">
									<table class="table" v-if="alerts && alerts.list && alerts.list.length">
										<thead>
										<tr>
											<th @click.prevent="sortBy('name')">
												სახელი
												<template v-if="isFilteredBy('name')">
													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
												</template>
											</th>
											<th @click.prevent="sortBy('value1')">
												განგაშის ტიპი
												<template v-if="isFilteredBy('value1')">
													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
												</template>
											</th>
											<th @click.prevent="sortBy('warehouse')">
												საწყობი
												<template v-if="isFilteredBy('warehouse')">
													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
												</template>
											</th>
											<th @click.prevent="sortBy('room')">
												ოთახი
												<template v-if="isFilteredBy('room')">
													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
												</template>
											</th>
											<th @click.prevent="sortBy('devices')">
												მოწყობილობა
												<template v-if="isFilteredBy('devices')">
													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>
												</template>
											</th>
<!--											<th @click.prevent="sortBy('sound')">-->
<!--												ხმა-->
<!--												<template v-if="isFilteredBy('sound')">-->
<!--													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>-->
<!--												</template>-->
<!--											</th>-->
<!--											<th @click.prevent="sortBy('popup')">-->
<!--												პოპაპ ფანჯარა-->
<!--												<template v-if="isFilteredBy('popup')">-->
<!--													<font-awesome-icon :icon="['fa' ,getIconByOrdering()]"/>-->
<!--												</template>-->
<!--											</th>-->
											<th>ქმედება</th>
										</tr>
										</thead>
										<tbody>
										<tr v-for="alert in alerts.list" :key="alert.id">
											<td>{{ alert.name }}</td>
											<td>{{ $t('alr_' + alert.alert_type.name) }}</td>
											<td>{{ alert.alldevices ? 'ყველა' : alert.alert_device.device_sensors[0].rooms[0].warehouse.name }}</td>
											<td>{{ alert.alldevices ? 'ყველა' : alert.alert_device.device_sensors[0].rooms[0].name }}</td>
											<td>{{ alert.alldevices ? 'ყველა' : alert.alertstypeid === 15 ? 'ყველა' : alert.devices }}</td>
<!--											<td>-->
<!--												<div :class="alert.sound ? 'green-circle' : 'gray-circle'"></div>-->
<!--											</td>-->
<!--											<td>-->
<!--												<div :class="alert.popup ? 'green-circle' : 'gray-circle'"></div>-->
<!--											</td>-->
											<td>
												<img src="/svgs/edit2.svg" @click.prevent="showEditAlert(alert.id);" alt="">
												<img src="/svgs/trash.svg" @click.prevent="removeAlert(alert.id)" alt="">
											</td>

										</tr>
										</tbody>
									</table>
								</div>

							</div>

						</transition>
					</div>
				</div>
			</div>
		</div>
		<LoaderItem custom-classes="splash-screen-child" v-if="this.loading"></LoaderItem>

	</div>
</template>

<script>
import AddAlertPopup from "@/components/alert/AddAlertPopup";
import {ref} from "vue";
import LoaderItem from "@/components/partials/LoaderItem";

export default {
	name: "AlertItem",
	components: {AddAlertPopup, LoaderItem},
	computed: {
		alerts() {
			return this.$store.state.alert.list.data
		},
		showAlert() {
			return this.$store.state.alert.showAlert
		},
	},
	methods: {
		isFilteredBy(key) {
			if (this.filteringState.key === key) {
				return true
			}
			return false
		},
		sortBy(key, nested = false) {
			this.changeFilterState(key)

			let splitedKey = key.split('.')[key.split('.').length - 1]

			this.alerts.list.sort((a, b) => {
				let comparableA = a[splitedKey]
				let comparableB = b[splitedKey]

				if (nested) {
					let path = nested.split('.')
					let tmpObj = null
					let tmpObjB = null
					for (let i = 0; i < path.length; i++) {
						if (i === 0) {
							tmpObj = a[path[0]]
							tmpObjB = b[path[0]]
							continue
						}
						tmpObj = tmpObj[path[i]]
						tmpObjB = tmpObjB[path[i]]

					}
					if (tmpObj && tmpObjB) {
						comparableA = tmpObj[splitedKey]
						comparableB = tmpObjB[splitedKey]
					}
				}

				if (this.filteringState.ordering === 'DESC') {
					return comparableA > comparableB ? 1 : -1
				} else {
					return comparableA < comparableB ? 1 : -1
				}
			})
		},
		changeFilterState(key) {
			if (this.filteringState.key === key) {
				this.filteringState.ordering = this.filteringState.ordering === 'ASC' ? 'DESC' : 'ASC'
				return
			}
			this.filteringState.key = key
			this.filteringState.ordering = 'DESC'
		},
		getIconByOrdering() {
			let icon = 'sort-down'
			if (this.filteringState.ordering === 'DESC') {
				icon = 'sort-up'
			}
			return icon
		},
		showAddAlertForm() {
			this.isShowingAlert = !this.isShowingAlert
			this.$refs.popupForm.alertModalTitle = 'განგაშის დამატება'
			this.$refs.popupForm.checkBindEdit(true)
		},
		showEditAlert(alertId) {
			this.$store.dispatch('alert/showAlert', alertId).then(
				() => {
					this.isShowingAlert = true
					this.$refs.popupForm.alertModalTitle = 'განგაშის რედაქტირება'
					this.$refs.popupForm.checkBindEdit()
					// eslint-disable-next-line no-undef
					let myModal = new bootstrap.Modal(document.getElementById('alertModalWizard'), {
						keyboard: false
					});
					myModal.toggle();
				}
			)
		},
		removeAlert(alertId) {
			this.$swal({
				title: '',
				text: "გსურთ განგაშის წაშლა?",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#F3F7FE',
				cancelButtonColor: '#F47B7A',
				confirmButtonText: 'დიახ, წავშალოთ',
				cancelButtonText: 'გაუქმება'
			}).then((result) => {
				if (result.isConfirmed) {
					this.loading = true
					this.$store.dispatch('alert/deleteAlert', alertId).then(
						() => {
							this.loading = false

							this.$swal({
								title: '',
								text: 'განგაში წაიშალა',
								confirmButtonText: 'დახურვა',
							})

						}
					)
				}
			})
		}
	},
	data() {
		return {
			loading: true,
			isShowingAlert: false,
			filteringState: ref({
				ordering: 'DESC',
				key: null
			})
		}
	},
	mounted() {
		this.$store.dispatch('alert/getAlerts').then(
			() => this.loading = false
		)
	}
}
</script>

<style scoped>

.table tbody tr:last-child {
	border-bottom: 1px solid var(--border-color) !important;
}


.search-pannel {
	padding-top: 20px;
	padding-bottom: 10px;
	border-bottom: 1px solid var(--border-color) !important;
}

.input-group-text {
	background-color: transparent;
}

.input-group-text {
	border: 0;
}

.input {
	border: 0;
}

.input-group {
	font-family: "TBCDinNusxuri-Medium";
	color: var(--nav-text-color);
}

.input-group, .input {
	background-color: var(--search-bg);
}

.input:hover, .input:active, .input:focus {
	box-shadow: none !important;
	background: transparent !important;
}

.content-body {
	padding-top: 20px;
	padding-left: 0;
	padding-right: 0;
}

.button-panel {
	float: right;
}

.table {
	text-align: left;
	color: var(--second-titles);
	font-family: "TBCDinNusxuri-Medium";
}

.table > :not(:first-child) {
	border: 1px solid var(--border-color) !important;
}

.table tbody tr:last-child {
	border: transparent;
}

.table tbody tr:hover {
	background: var(--hover-item);
	cursor: pointer;
}

.table > thead {
	vertical-align: middle;
	color: var(--text-sub-bold-color);
}

.table > :not(:first-child) {
	border-top: 1px solid var(--border-color);
}

.table td:first-child, table th:first-child {
	padding-left: 20px;
}

.content-header {
	padding-top: 5px;
	padding-bottom: 5px;
	border-bottom: 0;
}

.default-margin-top-content {
	margin-top: 2%;
}


</style>